<template>
  <div class="ml-auto py-2 pl-2 bg-dark">
    <div class="d-flex align-items-center justify-content-end">
      <b-button class="mr-2" @click="$root.$emit('ddex-remove')" variant="danger">
          <font-awesome-icon icon="trash-alt"/>
          <span class="ml-2">Remove</span>
      </b-button>
      <b-button class="mr-2" @click="$root.$emit('ddex-flag')" variant="secondary" v-if="selectedStatus !== 'Flagged'">
        <span class="ml-2">Flag</span>
      </b-button>
      <b-button class="mr-2" @click="$root.$emit('ddex-unflag')" variant="secondary" v-if="selectedStatus === 'Flagged'">
          <span class="ml-2">Unflag</span>
      </b-button>
      <b-button @click="$root.$emit('ddex-import')" variant="primary">
          <font-awesome-icon icon="cogs"/>
          <span class="ml-2">DDEX Import</span>
      </b-button>

      <div class="mx-1" style="margin-top: 2px;">
        <Icon icon="Scheiding" :size="24"/>
      </div>

      <b-button-group>
        <b-form-select class="mr-2" style="max-width: 150px" :value="selectedStatus" @input="updateStatus($event)" :options="statusOptions"></b-form-select>
        <b-input-group>
          <b-form-input ref="search" v-model="filterInput" placeholder="Type to Search" />
          <b-input-group-append>
            <b-button variant="btn-outline-light" :disabled="!filterInput" @click="filterInput = ''"><Icon icon="Search_backspace"/></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-button-group>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DdexToolbar',

  data: function() {
    return {
      filterInput: null,
      statusOptions: ['Available', 'Importing', 'Done', 'Flagged', 'Archived'],
      selectedStatus: "Available",
    };
  },

  props: {
    ddexType: String
  },

  watch: {
    filterInput(val) {
      this.$root.$emit('ddex-filter', val);
    }
  },

  methods: {
    focusSearch() {
      this.$refs.search.focus()
    },
    updateStatus(status) {
      this.selectedStatus = status;
      this.$root.$emit('ddex-status-filter', status);
    }
  },

  created() {
    this.$root.$on('ddex-focus-search', this.focusSearch)
  },

  beforeDestroy() {
    this.$root.$off('ddex-focus-search', this.focusSearch)
  }

}
</script>
